import { Pipe, PipeTransform } from '@angular/core';
import { numberUtil } from '../util/number-util';
import { locale as appLocale } from 'src/app/_services';

@Pipe({
    name: 'roundNumber',
    pure: true
})
export class RoundNumberPipe implements PipeTransform {
    transform(value: any, digits: number = 1) {
        return numberUtil.round(value, digits);
    }
}
